import { ToastMessage } from '@utility/toast';
import { useUnmapListing } from '../../hooks/use-unmap-listing';
import { mappingErrorMessage } from '../../lib/mapping-errors';
import { MappableListingsTable } from '../MappableListingsTable';
import { GatedButton } from './GatedButton';

const noop = () => {};

export type MappedViewProps = {
  isReadOnly?: boolean;
  isActionsHidden?: boolean;
};

/** Mapped listings, with Undo (back to the queue) next to the table's own Re-map. */
export function MappedView({ isReadOnly, isActionsHidden }: MappedViewProps) {
  const unmap = useUnmapListing();

  const undo = async (listingId: string) => {
    try {
      await unmap.mutateAsync(listingId);
      ToastMessage.success('Listing moved back to To review');
    } catch (failure) {
      ToastMessage.error(mappingErrorMessage(failure));
    }
  };

  return (
    <MappableListingsTable
      state="mapped"
      onStateChange={noop}
      hideStateTabs
      isReadOnly={isReadOnly}
      isActionsHidden={isActionsHidden}
      renderRowAction={listing => (
        <GatedButton
          variant="pill"
          size="sm"
          isReadOnly={isReadOnly}
          isDisabled={unmap.isPending}
          onPress={() => undo(listing.id)}
        >
          Undo
        </GatedButton>
      )}
    />
  );
}
